/* Filtrs theme | front-end behaviour. No external libraries. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var theme = window.theme || { routes: {} };
  var routes = theme.routes;

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var fmt = theme.moneyFormat || '${{amount}}';
    var n = Number(cents || 0) / 100;
    var withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return noDec;
      if (key === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return withDec;
    });
  }

  /* ---------- Toast ---------- */
  function toast(html) {
    var t = $('#Toast');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 4500);
  }

  /* ---------- Button labels (keep the Pass arrow) ---------- */
  function setBtnText(btn, txt) { var t = btn.querySelector('[data-add-text]'); if (t) t.textContent = txt; else btn.textContent = txt; }
  function addLabel(btn) {
    var root = btn.closest('[data-product]'); var q = root && root.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) || 1 : 1;
    return n > 1 ? 'Add ' + n + ' to cart' : btn.getAttribute('data-add-label');
  }
  document.addEventListener('change', function (e) {
    if (e.target.name !== 'quantity' && e.target.name !== 'tier-pick') return;
    var root = e.target.closest('[data-product]'); if (!root) return;
    var btn = root.querySelector('[data-add]');
    if (btn && btn.getAttribute('data-soldout') !== 'true') setBtnText(btn, addLabel(btn));
  });

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        return cart;
      });
  }

  /* ---------- Ajax add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-ajax-cart]') : null;
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    var data = new FormData(form);
    var drop = [];
    data.forEach(function (value, key) {
      if (key.indexOf('option-') === 0 || key === 'tier-pick' || (key === 'selling_plan' && !value)) drop.push(key);
    });
    drop.forEach(function (k) { data.delete(k); });

    fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Sorry, that could not be added.');
        return refreshCartCount().then(function () {
          toast('<span><strong>' + esc(res.d.product_title) + '</strong> added to your cart.</span><a href="' + routes.cart_url + '">View cart</a>');
        });
      })
      .catch(function (err) { toast('<span>' + esc(err.message) + '</span>'); })
      .then(function () { if (btn) btn.disabled = btn.getAttribute('data-soldout') === 'true'; });
  });

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-qty]') : null;
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart page: auto update quantities ---------- */
  $$('[data-cart-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'updates[]') return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        form.appendChild(hidden);
        form.submit();
      }, 600);
    });
  });

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach(function (wrap) {
    var input = $('input[name="q"]', wrap);
    var out = $('.predictive', wrap);
    if (!input || !out) return;
    var timer, controller;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.hidden = true; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var url = routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6' +
          '&resources[options][fields]=title,product_type,variants.sku,variants.barcode,vendor,tag';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = (d.resources && d.resources.results) || {};
            var html = '';
            var cols = res.collections || [];
            var prods = res.products || [];
            if (cols.length) {
              html += '<div class="predictive__heading">Categories</div>';
              html += cols.map(function (c) {
                return '<a class="predictive__item" href="' + c.url + '"><span class="predictive__title">' + esc(c.title) + '</span></a>';
              }).join('');
            }
            if (prods.length) {
              html += '<div class="predictive__heading">Filters</div>';
              html += prods.map(function (p) {
                var img = p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96' : '';
                var price = formatMoney(Math.round(parseFloat(p.price) * 100));
                return '<a class="predictive__item" href="' + p.url + '">' +
                  (img ? '<img src="' + img + '" alt="" loading="lazy" width="46" height="46">' : '') +
                  '<span><span class="predictive__title">' + esc(p.title) + '</span><br><span class="predictive__price">' + price + '</span></span></a>';
              }).join('');
            }
            if (!html) html = '<div class="predictive__heading">No quick matches for &quot;' + esc(q) + '&quot;</div>';
            html += '<a class="predictive__all" href="' + routes.search_url + '?q=' + encodeURIComponent(q) +
              '&type=product&options[prefix]=last">See all results for &quot;' + esc(q) + '&quot;</a>';
            out.innerHTML = html;
            out.hidden = false;
          })
          .catch(function () {});
      }, 220);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') out.hidden = true; });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) out.hidden = true; });
  });

  /* ---------- Filter finder ---------- */
  $$('[data-finder]').forEach(function (finder) {
    var tabs = $$('[data-finder-tab]', finder);
    var active = tabs[0];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
        tab.setAttribute('aria-pressed', 'true');
        active = tab;
      });
    });
    var form = $('form', finder);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = ($('[name="q"]', form).value || '').trim();
      var brandEl = $('[data-finder-brand]', form);
      var brand = brandEl ? brandEl.value : '';
      if (q) {
        window.location.href = routes.search_url + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
        return;
      }
      var base = active ? active.getAttribute('data-url') : routes.root + 'collections/all';
      window.location.href = brand ? base.replace(/\/$/, '') + '/' + brand : base;
    });
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var stockEl = $('[data-variant-stock]', root);
    var stock = stockEl ? JSON.parse(stockEl.textContent) : {};
    var lowAt = parseInt(root.getAttribute('data-low-stock') || '5', 10);
    var form = $('form[data-ajax-cart]', root);
    if (!form) return;
    var idInput = $('input[name="id"]', form);
    var priceEl = $('[data-price]', root);
    var skuEl = $('[data-sku]', root);
    var btn = $('[data-add]', root);
    var stockBox = $('[data-stock]', root);

    function showMedia(id) {
      if (!id) return;
      var slide = $('[data-media-id="' + id + '"]', root);
      if (!slide) return;
      $$('[data-media-id]', root).forEach(function (s) { s.hidden = s !== slide; });
      $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') == id ? 'true' : 'false'); });
    }
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });

    function update() {
      var selected = $$('[data-option]', root).map(function (fs) {
        var c = $('input:checked', fs);
        var legend = $('legend span', fs);
        if (legend && c) legend.textContent = c.value;
        return c ? c.value : null;
      });
      var variant = product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      if (!variant) {
        btn.disabled = true; btn.setAttribute('data-soldout', 'true'); setBtnText(btn, 'Unavailable');
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.innerHTML = '<span class="price__current">' + formatMoney(variant.price) + '</span>' + (sale ? '<s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
        priceEl.classList.toggle('price--sale', !!sale);
      }
      if (skuEl) $$('[data-sku]', root).forEach(function (el) { el.textContent = variant.sku || ''; });
      root.dispatchEvent(new CustomEvent('filtrs:variant', { detail: variant }));
      var sp = $('[data-sticky-price]', root); if (sp) sp.textContent = formatMoney(variant.price);
      btn.disabled = !variant.available;
      btn.setAttribute('data-soldout', variant.available ? 'false' : 'true');
      setBtnText(btn, variant.available ? addLabel(btn) : btn.getAttribute('data-sold-label'));
      if (stockBox) {
        var info = stock[variant.id] || {};
        var q = info.q === undefined ? null : info.q;
        var text = $('[data-stock-text]', stockBox);
        var sub = $('[data-stock-sub]', stockBox);
        stockBox.classList.remove('stock--low', 'stock--out', 'stock--order');
        if (sub) sub.hidden = false;
        if (!variant.available) { stockBox.classList.add('stock--out'); text.textContent = 'Sold out'; if (sub) sub.hidden = true; }
        else if (q !== null && q <= 0 && info.c) { stockBox.classList.add('stock--order'); text.textContent = stockBox.getAttribute('data-order-in'); if (sub) sub.hidden = true; }
        else if (q !== null && q > 0 && q <= lowAt && !info.c) { stockBox.classList.add('stock--low'); text.textContent = 'Low stock, only ' + q + ' left'; }
        else { text.textContent = stockBox.getAttribute('data-in-stock'); }
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-option] input', root).forEach(function (i) { i.addEventListener('change', update); });
  });

  /* ---------- Compatibility checker ---------- */
  $$('[data-compat]').forEach(function (box) {
    var input = $('input', box);
    var items = $$('.compat__list li', box);
    var msg = $('[data-compat-msg]', box);
    var norm = function (s) { return s.toLowerCase().replace(/[\s\-_.\/]/g, ''); };
    input.addEventListener('input', function () {
      var q = norm(input.value.trim());
      var n = 0;
      items.forEach(function (li) {
        var match = !q || norm(li.textContent).indexOf(q) > -1;
        li.hidden = !match;
        if (match) n++;
      });
      var raw = input.value.trim().toUpperCase();
      msg.classList.remove('is-yes', 'is-no');
      box.classList.remove('fit--fits', 'fit--nofit');
      if (!q) { msg.textContent = ''; return; }
      if (n) { msg.innerHTML = 'Fits your <span class="mono">' + raw.replace(/[<>&"]/g, '') + '</span>' + (n > 1 ? '. ' + n + ' matching models listed.' : ''); msg.classList.add('is-yes'); box.classList.add('fit--fits'); }
      else { msg.innerHTML = 'Not a match for <span class="mono">' + raw.replace(/[<>&"]/g, '') + '</span>. Send us a photo of the old filter and we will match it for you.'; msg.classList.add('is-no'); box.classList.add('fit--nofit'); }
    });
  });

  /* ---------- Collection and search filters ---------- */
  function submitFacets(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    window.location.search = params.toString();
  }
  document.addEventListener('change', function (e) {
    var f = e.target.form;
    if (!f || !f.hasAttribute('data-facets-form')) return;
    if (e.target.hasAttribute('data-price-input')) return;
    submitFacets(f);
  });
  $$('form[data-facets-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(f); });
  });
  $$('[data-facets-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (!panel) return;
      var open = panel.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) {
        el.innerHTML = inner.innerHTML;
        var wrap = el.closest('[data-recommendations-section]');
        if (wrap) wrap.hidden = false;
      }
    }).catch(function () {});
  });

  /* ---------- Customer address country defaults ---------- */
  $$('select[data-default]').forEach(function (s) {
    var d = s.getAttribute('data-default');
    if (d) s.value = d;
  });

  /* ---------- Multi-buy tier picker ---------- */
  $$('[data-tiers]').forEach(function (box) {
    var root = box.closest('[data-product]') || document;
    var qty = $('input[name="quantity"]', root);
    var g = function (k) { return box.getAttribute('data-' + k); };
    var t1q = +g('t1q'), t2q = +g('t2q');
    function save(type, v, full) { return type === 'percent' ? full * v / 100 : v * 100; }
    var radios = $$('input[name="tier-pick"]', box);
    radios.forEach(function (r) { r.addEventListener('change', function () { if (qty) qty.value = r.value; }); });
    if (qty) qty.addEventListener('change', function () {
      var n = parseInt(qty.value, 10) || 1;
      var pick = n >= t2q ? String(t2q) : n >= t1q ? String(t1q) : '1';
      radios.forEach(function (r) { r.checked = r.value === pick; });
    });
    root.addEventListener('filtrs:variant', function (e) {
      var p = e.detail.price;
      var s1 = save(g('t1type'), +g('t1v'), p * t1q);
      var s2 = Math.max(save(g('t2type'), +g('t2v'), p * t2q), save(g('t1type'), +g('t1v'), p * t2q));
      var set = function (sel, cents) { var el = $(sel, box); if (el) el.textContent = formatMoney(Math.max(0, Math.round(cents))); };
      set('[data-tier-total="1"]', p);
      set('[data-tier-total="' + t1q + '"]', p * t1q - s1);
      set('[data-tier-each="' + t1q + '"]', (p * t1q - s1) / t1q);
      set('[data-tier-total="' + t2q + '"]', p * t2q - s2);
      set('[data-tier-each="' + t2q + '"]', (p * t2q - s2) / t2q);
      var sv = $('[data-tier-save="' + t2q + '"]', box);
      if (sv) sv.textContent = 'Save ' + formatMoney(Math.round(s2));
      box.hidden = !e.detail.available;
    });
  });

  /* ---------- Same-day dispatch countdown (Perth time, weekdays) ---------- */
  $$('[data-cutoff]').forEach(function (box) {
    var sub = $('[data-stock-sub]', box);
    if (!sub) return;
    var cutoff = parseInt(box.getAttribute('data-cutoff'), 10);
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    function tick() {
      if (box.classList.contains('stock--order') || box.classList.contains('stock--out')) return;
      var perth = new Date(Date.now() + 8 * 3600000);
      var day = perth.getUTCDay(), mins = perth.getUTCHours() * 60 + perth.getUTCMinutes();
      var left = cutoff * 60 - mins;
      if (day >= 1 && day <= 5 && left > 0) {
        var h = Math.floor(left / 60), m = left % 60;
        sub.innerHTML = 'Order in the next <strong>' + (h ? h + ' h ' : '') + m + ' min</strong> and it ships today from Perth.';
      } else {
        var next = (day + 1) % 7;
        while (next === 0 || next === 6) next = (next + 1) % 7;
        sub.innerHTML = 'Order now and it ships <strong>' + (next === (day + 1) % 7 ? 'tomorrow' : days[next]) + '</strong> from Perth.';
      }
    }
    tick();
    setInterval(tick, 30000);
  });

  /* ---------- Sticky add to cart ---------- */
  $$('[data-sticky-buy]').forEach(function (bar) {
    var root = bar.closest('[data-product]');
    var main = root && $('[data-add]', root);
    if (!main || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(main);
  });
})();
